import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from '@core/services/config.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class BootstrapModule {
  constructor(private configService: ConfigService) {
    this.configService.initialIcons();
  }
}
